import { render, staticRenderFns } from "./ConnectionStatus.vue?vue&type=template&id=b87a2676&scoped=true"
import script from "./ConnectionStatus.vue?vue&type=script&lang=js"
export * from "./ConnectionStatus.vue?vue&type=script&lang=js"
import style0 from "./ConnectionStatus.vue?vue&type=style&index=0&id=b87a2676&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a2676",
  null
  
)

export default component.exports